import { render, staticRenderFns } from "./officialNumberAll.vue?vue&type=template&id=c1fde602&scoped=true&"
import script from "./officialNumberAll.vue?vue&type=script&lang=js&"
export * from "./officialNumberAll.vue?vue&type=script&lang=js&"
import style0 from "./officialNumberAll.vue?vue&type=style&index=0&id=c1fde602&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fde602",
  null
  
)

export default component.exports